import { render, staticRenderFns } from "./DirectorDetails.vue?vue&type=template&id=bb8a8b3e&scoped=true&"
import script from "./DirectorDetails.vue?vue&type=script&lang=js&"
export * from "./DirectorDetails.vue?vue&type=script&lang=js&"
import style0 from "./DirectorDetails.vue?vue&type=style&index=0&id=bb8a8b3e&scoped=true&lang=css&"
import style1 from "./DirectorDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8a8b3e",
  null
  
)

export default component.exports